<template>
<div>
    <b-table striped responsive borderless :fields="header" :items="attributes">
        <template v-slot:cell(delete)="data">
            <template v-if="isOtherMode || data.item.key === null || (data.item.key.includes('itemCode') !== true && data.item.key.includes('name') !== true && data.item.key.includes('systemId') !== true)">
                <b-form-checkbox v-model="data.item.checked"></b-form-checkbox>
            </template>
        </template>
        <template v-slot:cell(key)="data">
            <template v-if="isOtherMode">
                <b-form-input v-model.trim="data.item.key" @input="changeItem($event, data.item)"></b-form-input>
            </template>
            <template v-else-if="data.item.key !== null || data.item.isDisabled">
                <b-form-input v-model="data.item.key" disabled></b-form-input>
            </template>
            <template v-else>
                <b-form-select v-model="data.item.key" :options="keyOption" @change="changeItemKey($event,data.item, data.field.key)">
                </b-form-select>
            </template>
        </template>
        <template v-slot:cell(name)="data">
            <b-form-input v-model="data.item.name" @input="changeItem($event, data.item, data.field.key)" :disabled="data.item.isDisabled"></b-form-input>
        </template>
        <template v-slot:cell(inputType)="data">
            <template v-if="data.item.key !== 'itemCode' && data.item.key !== 'name' && data.item.key !== 'systemId'">
                <b-form-select v-model="data.item.inputType" :options="[
                            { value: 0, text: 'Text'},
                            { value: 1, text: 'List'},
                            { value: 2, text: 'Date' },
                            { value: 3, text: 'Location' },
                            { value: 31, text: 'Warehouse' },
                            { value: 32, text: 'Menu' },
                            { value: 4, text: 'DateTime' },
                            { value: 5, text: 'Checkbox' },
                            { value: 6, text: 'Checkbox And Date' },
                            { value: 7, text: 'URL' }
                        ]" @change="changeSelectItem($event, data.item, data.field.key)">
                </b-form-select>
                <b-form-input v-if="data.item.showInputFlag" v-model="data.item.items" @input="changeInputItem($event, data.item, data.field.key)" style="margin-top:10px"></b-form-input>
                <div class="attr_warning" v-if="data.item.checkInputFlag">{{ $t("attributes.not_json") }}</div>
            </template>
        </template>
        <template v-slot:cell(order)="data">
            <b-form-input type="number" v-model.number="data.item.order" @input="changeItem($event, data.item)"></b-form-input>
        </template>
        <template v-slot:cell(searchOrder)="data">
            <b-form-input type="number" v-model.number="data.item.searchOrder" @input="changeItem($event, data.item)"></b-form-input>
        </template>
    </b-table>
    <div class="d-flex justify-content-between px-2">
        <ButtonAdd @click="attributeAddEmptyInput"></ButtonAdd>
        <div>
            <ButtonSave @click="updateOrCreateAttributes"></ButtonSave>
            <ButtonDelete @click="deleteAttributes"></ButtonDelete>
        </div>
    </div>
    <div class="attr_warning" v-if="isOtherMode">{{ $t("attributes.other_key_format") }}</div>
    <div class="attr_warning" v-else>{{ $t("attributes.re_register_master") }}</div>
</div>
</template>

<script>
import ButtonEdit from "../components/buttons/ButtonEdit.vue";
import ButtonAdd from "../components/buttons/ButtonAdd.vue";
import ButtonDelete from "../components/buttons/ButtonDelete.vue";
import ButtonSave from "../components/buttons/ButtonSave.vue";
import * as queries from "../graphql/locus_queries"
import * as mutations from "../graphql/locus_mutations";
import global from "../Global.vue";
import AwsApi from '../Api';
import {
    API
} from "aws-amplify";

export default {
    props: ['type'],
    components: {
        ButtonSave,
        ButtonDelete,
        ButtonAdd,
        ButtonEdit,
    },
    computed: {
        attributes() {
            if (!this.isOtherMode) {
                return [...this.attributesApi, ...this.attributesAdd]
            }
            return [...this.sortBySourceTable(this.attributesApi), ...this.attributesAdd]
        },
        isOtherMode() {
            return this.type === 4
        }
    },
    data() {
        return {
            tenantId: "",
            attributesApi: [],
            attributesAdd: [],
            attr_errors: [],
            sourceTable: "ItemMaster",
            header: [{
                key: "delete",
                label: this.$t("select"),
            }, {
                key: "key",
                label: this.$t("attr_key"),
            }, {
                key: "name",
                label: this.$t("attr_name"),
            }, {
                key: "inputType",
                label: this.$t("attr_type"),
            }],
            keyOptionDefault: [],
            keyOption: []
        }
    },
    mounted() {
        this.tenantId = sessionStorage.getItem(global.tenantId)
        if (this.isOtherMode) {
            this.sourceTable = null
        } else if (this.type === 0) {
            this.sourceTable = "ItemMaster"
        } else if (this.type === 2) {
            this.sourceTable = "Job"
        } else {
            this.sourceTable = { 5: "JobDetail", 6: "JobEpc", 7: "Stock" }[this.type]
        }

        if (this.type === 0 || this.isOtherMode) {
            this.header.push({ key: "order", label: this.$t("display_order") })
        }
        if (this.isOtherMode) {
            this.header.push({ key: "searchOrder", label: this.$t("search_order") })
        }
        this.fetchAttributes()
        if (!this.isOtherMode) {
            this.getDefaultKey()
        }
    },
    methods: {
        async fetchAttributes() {
            const items = this.isOtherMode
                ? await this.fetchOtherItemDefines()
                : await this.fetchItemDefinesBySourceTable()
            this.attributesApi = [...this.attributeMapApiResponse(items)]
            this.setKeyOption()
        },
        async fetchItemDefinesBySourceTable() {
            const response = await AwsApi.graphql({
                query: queries.queryItemDefines,
                variables: {
                    sourceTable: {
                        eq: this.sourceTable
                    },
                    tenantId: this.tenantId
                }
            }, this);
            if (response === undefined) {
                return []
            }
            return response.data.queryItemDefines.items || []
        },
        async fetchOtherItemDefines() {
            const reservedTables = ["ItemMaster", "Job", "JobDetail", "JobEpc", "Stock"]
            let items = []
            let nextToken = null
            do {
                const response = await AwsApi.graphql({
                    query: queries.listItemDefines,
                    variables: {
                        tenantId: this.tenantId,
                        limit: 1000,
                        nextToken
                    }
                }, this);
                if (response === undefined) {
                    return items
                }
                items = items.concat(response.data.listItemDefines.items || [])
                nextToken = response.data.listItemDefines.nextToken
            } while (nextToken)
            return items.filter(item => !reservedTables.includes(item.sourceTable))
        },
        async getDefaultKey() {
            const response = await AwsApi.graphql({
                query: queries.getAddableItems,
                variables: {
                    tableName: this.sourceTable
                }
            }, this);
            this.keyOptionDefault = response.data.getAddableItems
            this.setKeyOption()
        },
        async setKeyOption() {
            if (this.isOtherMode) {
                return
            }
            this.keyOption = this.keyOptionDefault.filter(item1 => item1 === "properties" || !this.attributes.some(item2 => {
                return item2.source !== undefined && item2.source.includes(item1) || item2.key !== null && item2.key.includes(item1)
            }));
        },
        getItemSource(item) {
            return (item.key || item.source || "").trim()
        },
        getItemSourceTable(item) {
            const source = this.getItemSource(item)
            const funcInner = source.match(/^[A-Za-z]+\((.+)\)$/)
            if (funcInner) {
                return funcInner[1].split('.')[0] || ""
            }
            if (source.includes('.')) {
                return source.split('.')[0]
            }
            return item.sourceTable || source
        },
        isAggregateSource(item) {
            return /^[A-Za-z]+\(.+\)$/.test(this.getItemSource(item))
        },
        sortBySourceTable(list) {
            return [...list].sort((a, b) => {
                const tableCompare = this.getItemSourceTable(a).localeCompare(this.getItemSourceTable(b))
                if (tableCompare !== 0) {
                    return tableCompare
                }
                const aggregateCompare = Number(this.isAggregateSource(a)) - Number(this.isAggregateSource(b))
                if (aggregateCompare !== 0) {
                    return aggregateCompare
                }
                return (a.order || 0) - (b.order || 0)
            })
        },
        attributeMapApiResponse(response) {
            const resSort = this.isOtherMode
                ? this.sortBySourceTable(response)
                : [...response].sort(function (a, b) {
                    return a.order - b.order
                });
            const properties = []
            var allAttributes = []

            resSort.forEach(item => {
                const current = allAttributes.find(attr => item.source.includes(attr.key))
                if (current !== undefined) {
                    current.name = item.name
                    current.inputType = item.inputType
                    current["source"] = item.source
                    current.toCreate = false
                    current.order = item.order
                } else {
                    if (!this.isOtherMode && item.source.includes("properties")) {
                        item["isDisabled"] = true
                    }
                    
                    properties.push(item)
                }
            })
            allAttributes = [...allAttributes, ...properties]
            const res = allAttributes.map((element) => {
                if(element.inputType === 1){
                    element.showInputFlag = true
                } else {
                    element.showInputFlag = false
                }
                if (element.source) {
                    const items = element.source.split('.')
                    element["key"] = this.isOtherMode || this.isAggregateSource(element) ? element.source : items[1]
                    element["originalSource"] = element.source
                    element["checked"] = false
                    return element
                } else {
                    element["checked"] = false
                    return element
                }
            })
            return res
        },

        attributeAddEmptyInput() {
            const emptyAttribute = {
                key: this.isOtherMode ? "" : null,
                name: null,
                inputType: 0,
                checked: false,
                toCreate: true
            };
            return this.attributesAdd = [...this.attributesAdd, emptyAttribute]
        },
        buildSource(item) {
            if (this.isOtherMode || this.isAggregateSource(item)) {
                return (item.key || "").trim()
            }
            return item.key.includes('properties') === false ? this.sourceTable + "." + item.key : this.sourceTable + "." + item.key + "." + item.name
        },
        buildSourceTable(item) {
            if (this.isOtherMode) {
                return (item.key || "").trim().split('.')[0]
            }
            return this.sourceTable
        },
        validateOtherKey(key) {
            const value = (key || "").trim()
            const parts = value.split('.')
            if (parts.length < 2 || !parts[0] || !parts[1]) {
                return "attributes.other_key_format"
            }
            if (["ItemMaster", "Job", "JobDetail", "JobEpc", "Stock"].includes(parts[0])) {
                return "attributes.other_key_reserved"
            }
            return null
        },

        async deleteAttributes() {
            AwsApi.checkSession(() => {
                const deletePro = []

                const item_to_delete = this.attributesApi
                    .filter(attribute => attribute.checked)
                    .map(attribute => attribute.source);
                this.attributesAdd = this.attributesAdd.filter(attribute => !attribute.checked)
                if (item_to_delete.length > 0) {
                    API.graphql({
                        query: queries.listMenuConfigs,
                        variables: {
                            tenantId: this.tenantId
                        }
                    }).then(response => {
                        item_to_delete.forEach((item, index) => {
                            var deleteAttribute = {
                                tenantId: this.tenantId,
                                source: item
                            }
                            deletePro.push(API.graphql({
                                query: mutations.deleteItemDefine,
                                variables: {
                                    input: deleteAttribute
                                }
                            }));

                            response.data.listMenuConfigs.items.forEach(menuItem => {
                                if (item === menuItem.source) {
                                    const deleteItem = {
                                        tenantId: this.tenantId,
                                        id: menuItem.id
                                    }
                                    deletePro.push(API.graphql({
                                        query: mutations.deleteMenuConfig,
                                        variables: {
                                            input: deleteItem
                                        }
                                    }));
                                }
                            })
                        })
                        Promise.all([...deletePro]).then(() => this.fetchAttributes())
                    })
                }
                this.setKeyOption()
            }, this)
        },

        async updateOrCreateAttributes() {
            AwsApi.checkSession(async () => {
                const create = []
                const update = []
                const deletePro = []

                var item_to_create = [...this.attributesAdd.filter(attr => attr.key && attr.name !== "" && attr.name !== null), ...this.attributesApi.filter(attr => attr.toCreate && attr.key && attr.name !== "" && attr.name !== null)];

                const uniqueArray = [];

                item_to_create.forEach(item => {
                    if (!uniqueArray.some(obj => obj.key === item.key && obj.key !== "properties")) {
                        uniqueArray.push(item);
                    }
                });
                item_to_create = uniqueArray
                const item_to_update = [...this.attributesApi.filter(attr => !attr.toCreate && attr.toUpdate)];
                if (this.isOtherMode) {
                    for (const item of [...item_to_create, ...item_to_update]) {
                        const errorKey = this.validateOtherKey(item.key)
                        if (errorKey) {
                            alert(this.$t(errorKey))
                            return
                        }
                    }
                }
                const item_to_rename = this.isOtherMode
                    ? item_to_update.filter(item => item.originalSource && this.buildSource(item) !== item.originalSource)
                    : []
                const item_to_update_inplace = item_to_update.filter(item => !item_to_rename.includes(item))

                var order = 0
                if (this.attributesApi.length != 0) {
                    order = this.attributesApi[this.attributesApi.length - 1].order + 1
                }

                item_to_create.forEach((item, index) => {
                    var createAttribute = {
                        group: this.tenantId,
                        tenantId: this.tenantId,
                        source: this.buildSource(item),
                        name: item.name,
                        sourceTable: this.buildSourceTable(item),
                        inputType: item.inputType,
                        items: item.items,
                        order: item.order === undefined || item.order === null || item.order === "" ? order + index : item.order,
                        ...(this.isOtherMode ? { searchOrder: item.searchOrder === "" ? null : item.searchOrder } : {})
                    }
                    create.push(API.graphql({
                        query: mutations.createItemDefine,
                        variables: {
                            input: createAttribute
                        }
                    }));
                    this.attributesAdd = this.attributesAdd.filter(attr => item.id !== attr.id)
                })
                item_to_update_inplace.forEach((item) => {
                    item.toUpdate = false
                    var updateAttribute = {
                        group: this.tenantId,
                        tenantId: this.tenantId,
                        source: this.buildSource(item),
                        name: item.name,
                        sourceTable: this.buildSourceTable(item),
                        inputType: item.inputType,
                        items: item.items,
                        ...(this.type === 0 || this.isOtherMode ? { order: item.order === "" ? null : item.order } : {}),
                        ...(this.isOtherMode ? { searchOrder: item.searchOrder === "" ? null : item.searchOrder } : {})
                    }
                    update.push(API.graphql({
                        query: mutations.updateItemDefine,
                        variables: {
                            input: updateAttribute
                        }
                    }));
                })
                if (item_to_rename.length > 0) {
                    const menuResponse = await API.graphql({
                        query: queries.listMenuConfigs,
                        variables: {
                            tenantId: this.tenantId
                        }
                    })
                    const menuItems = menuResponse.data.listMenuConfigs.items || []
                    item_to_rename.forEach((item) => {
                        item.toUpdate = false
                        const newSource = this.buildSource(item)
                        const menuUpdates = menuItems
                            .filter(menuItem => menuItem.source === item.originalSource)
                            .map(menuItem => API.graphql({
                                query: mutations.updateMenuConfig,
                                variables: {
                                    input: {
                                        tenantId: this.tenantId,
                                        id: menuItem.id,
                                        source: newSource
                                    }
                                }
                            }))
                        create.push(
                            API.graphql({
                                query: mutations.createItemDefine,
                                variables: {
                                    input: {
                                        group: this.tenantId,
                                        tenantId: this.tenantId,
                                        source: newSource,
                                        name: item.name,
                                        sourceTable: this.buildSourceTable(item),
                                        inputType: item.inputType,
                                        items: item.items,
                                        order: item.order,
                                        ...(this.isOtherMode ? { searchOrder: item.searchOrder === "" ? null : item.searchOrder } : {})
                                    }
                                }
                            }).then(() => Promise.all([
                                API.graphql({
                                    query: mutations.deleteItemDefine,
                                    variables: {
                                        input: {
                                            tenantId: this.tenantId,
                                            source: item.originalSource
                                        }
                                    }
                                }),
                                ...menuUpdates
                            ]))
                        )
                    })
                }
                Promise.all([...create, ...update, ...deletePro]).then(() => this.fetchAttributes())
            }, this)
        },
        changeItem(value, cell, key) {
            cell.toUpdate = true
        },
        changeSelectItem(value, cell, key) {
            cell.toUpdate = true
            if(value === 1){
                cell.showInputFlag = true
            } else {
                cell.showInputFlag = false
                cell.items = null
            }
        },
        changeInputItem(value, cell, key) {
            try {
                if (typeof value !== 'string') {
                    throw new Error('not string')
                }

                if (value.trim() === '') {
                    cell.items = null
                    cell.toUpdate = true
                    cell.checkInputFlag = false
                    return
                }

                const parsed = JSON.parse(value)

                if (typeof parsed !== 'object' || parsed === null) {
                    throw new Error('not object json')
                }

                cell.items = value
                cell.toUpdate = true
                cell.checkInputFlag = false
            } catch (e) {
                cell.checkInputFlag = true
            }
        },
        changeItemKey(value, cell, key) {
            cell.key = value
            this.setKeyOption()
        }
    },

}
</script>

<style>
.hidden_header {
    display: none;
}

.attr_warning {
    float: left;
    margin-top: 15px;
    font-weight: 600;
    color: red;
}
</style>
